import React, { useState } from "react";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home  from "./components/Home";
import About from "./components/About";
import Contact from "./components/Contact";
import Login from "./components/Login";
import SignUp from "./components/SignUp";
import Stand from "./components/Stand";
import Profile from './components/Profile';

const App = () => {
  const [email,setemail] = useState("");
  const [token,settoken] = useState(null);
  return (
    <div>
      {/* <Navbar /> */}
      {/* <Stand /> */}
      <Navbar token={token}/>
      <Routes>
        <Route path="/stand" element={<Stand />} />
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/login" element={<Login 
           email={email}
          token={token}
          setemail={setemail}
          settoken={settoken}
        />} />
        <Route path="/signup" element={<SignUp 
          email={email}
          token={token}
          setemail={setemail}
          settoken={settoken}
        />} />
        <Route path="/stand" element={<Stand />} />
        <Route path="/profile" element={<Profile email={email} token={token} settoken={settoken} setemail={setemail} />} />
      </Routes>
    </div>
  );
};

export default App;
